var exports = {
  "ne": "x127c5a35--07c4da--controls",
  "qS": "x127c5a35--07c4da--print-mode",
  "pw": "x127c5a35--07c4da--book_button",
};

module.exports = exports;
